import { CountrySelectorUpdateOnChange } from "@made-people/blueprint-site-settings";

export const MMShippingCountrySelector = () => {
  return (
    <div className="w-full">
      <CountrySelectorUpdateOnChange label={false} />
    </div>
  );
};
